module.exports = __webpack_public_path__ + "media/images/banner/tamatex/tamatex-2f5f4959d43bf1cfe443b0b1af3bcc02.jpg";